import {useTranslation} from 'react-i18next';

import {Box, Typography} from '@mui/material';

import {WalkthroughTrigger} from '../../../../../features/walkthroughs';

export const PageHeader = () => {
  const {t} = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        mb: 3,
      }}
    >
      <Typography variant='h1' data-tour='surveys.title'>
        {t('companySurveys.header.title')}
      </Typography>
      <WalkthroughTrigger walkthroughId='companySurveys' />
    </Box>
  );
};
